import { jwtDecode } from 'jwt-decode'
import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import localStorageService from 'services/localStorageService'

const AuthGuard = ({ children }) => {
    const { isAuthenticated } = useSelector(state => state.auth)
    const location = useLocation()
    let refresh_token = localStorageService.getItem('access_token');
    if(refresh_token){
        const decoded = jwtDecode(refresh_token);
        if (decoded.exp * 1000 < Date.now()) {
            localStorageService.removeItem('access_token');
            localStorageService.removeItem('refresh_token');
            localStorageService.removeItem('user');
            return <Navigate to="/login" state={{ from: location }} replace />
        }
    }

    
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return children
}

export default AuthGuard 